export function dollarsToCents(dollars: number, round = false): number {
    const cents = dollars * 100;
    if (round) return Math.round(cents);
    return cents;
}

export function centsToDollars(cents: number): number {
    return cents * 0.01;
}
